import { ApiResponse } from 'apisauce';
import { ErrorInfo } from '../../../shared/interfaces/error-info.interface';
import api from '../../../shared/services/utils/api/api.service';
import errorHelper from '../../../shared/services/utils/api/error-helper.service';

export const getModuleName = () => 'operation-dashboard-module';

export type OperationDashboardSummary = {
  checkinsTotal: number;
  checkinsDone: number;
  checkoutsTotal: number;
  checkoutsDone: number;
  housekeepingTotal: number;
  housekeepingDone: number;
  MaintenanceTotal: number;
  MaintenanceDone: number;
};

export async function getOperationDashboardSummary(): Promise<
  OperationDashboardSummary | ErrorInfo
> {
  const normalized: ApiResponse<any, ErrorInfo> = await (api as any).getOperationDashboardSummary();

  if (normalized.ok) {
    const payload = normalized.data?.data || normalized.data;
    if (payload?.data) {
      return payload.data;
    }
    return payload;
  }

  return errorHelper(
    Number(normalized.status),
    (normalized.data as any)?.errorCode
      ? String((normalized.data as any)?.errorCode || '')
      : normalized.problem,
    getModuleName(),
    'getOperationDashboardSummary'
  );
}
